import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import Grid from 'grid-styled'
import { Fonts, Metrics, Colors } from '../../Themes'
import styled from 'styled-components'
import Button from '../../components/Button'
import HvbWhite from '../../svg-icons/HvbWhite'
import AuthStore from '../../stores/AuthStore'
import landingVideo from '../../../public/img/Landing/intro-video.mp4'
import landingImage from '../../../public/img/Landing/intro-image.png'

const LandingContainer = styled.div`
  display: block;
  width: 100vw;
  height: 100vh;
  position: relative;

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    height: 100vh;
  }
`

const Contacts = styled.div`
  height: ${Metrics.components.landingFooter};
  width: 100vw;
  text-align: center;
  background-color: ${Colors.white};
`

const Contact = styled(Grid)`
  ${Fonts.style.Text};
  padding: ${Metrics.margins.medium} 0;
`

const BackgroundVideo = styled.video`
  object-fit: fill;
  width: 100vw;
  height: 100vh;
  display: block;
  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    object-fit: cover;
  }
`

const BackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.3;
  background: url(${landingImage}) no-repeat center;
  background-size: cover;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  filter: blur(2px);
  pointer-events: none;
`

const Container = styled.main`
  text-align: center;
  height: 100vh;
  overflow-y: scroll;
`

const InfosContainer = styled.div`
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
  height: 100vh;
  position: relative;
`

const Title = styled.div`
  ${Fonts.style.Header};
  color: ${Colors.white};
`

const CustomButton = styled(Button)`
  margin-top: ${Metrics.margins.big};
`

const AboutButton = styled(CustomButton)`
  margin-right: ${Metrics.margins.small};
`

const LogoContainer = styled.div`
  width: ${Metrics.components.landingLogoSize};
  margin-left: calc((100% - ${Metrics.components.landingLogoSize})/2)
  border-bottom: ${Metrics.borders.orangeBorder};
  margin-bottom: ${Metrics.margins.larger};
`

const Body = styled.div`padding: ${Metrics.margins.base} 0;`

const StyledGrid = styled(Grid)`
  text-align: center;
  padding: ${Metrics.margins.small} 0;
  ${Fonts.style.Text};
  color: ${Colors.primary};
`

const Intro = styled.div`padding: ${Metrics.margins.big};`

const ContainerWithBorder = styled.div`
  border-bottom: ${Metrics.borders.default};
  border-top: ${Metrics.borders.default};
  padding: ${Metrics.margins.base};
`

const Description = styled.p`
  line-height: ${Metrics.margins.large};
  color: ${Colors.black};
`

const Wrapper = styled.div`
  position: absolute;
  display: table;
  width: 100vw;
  height: 100vh;
  top: 0;
  background: rgba(48, 48, 48, 0.8);
`

class Landing extends Component {
  componentWillUpdate (nextProps, nextState) {
    if (!this.props.user && nextProps.user) {
      this.props.router.replace('/')
    }
  }

  static getInitialState () {
    return AuthStore.getState()
  }

  static getStores () {
    return [ AuthStore ]
  }

  static getPropsFromStores () {
    let authState = AuthStore.getState()
    return {
      user: authState.user,
      fetching: authState.fetching,
      errorMessage: authState.errorMessage
    }
  }

  getBackground () {
    if (
      window.matchMedia(`(min-width:${Metrics.breakpoints.tablet})`).matches
    ) {
      return (
        <BackgroundVideo loop autoPlay>
          <source src={landingVideo} type='video/mp4' />
        </BackgroundVideo>
      )
    }
    return <BackgroundImage />
  }

  render () {
    const { t, children, router } = this.props

    return (
      <Container>
        <LandingContainer>
          {this.getBackground()}
          {children || (
            <Wrapper>
              <InfosContainer>
                <LogoContainer>
                  <HvbWhite />
                </LogoContainer>
                <Title>{t('Discretion, Trust, Excellence')}</Title>
                <AboutButton
                  label={t('About Pangaea')}
                  onClick={() => router.push('/landing/about_pangaea')}
                />
                <CustomButton
                  primary
                  label={t('Login')}
                  onClick={() => router.push('/landing/login')}
                />
              </InfosContainer>
            </Wrapper>
          )}
        </LandingContainer>
        {!children && (
          <div>
            <Body>
              <div>
                <StyledGrid md={1 / 8} />
                <StyledGrid md={3 / 4}>
                  <Intro>
                    <Description>
                      {t(
                        `HvB Investments is a boutique Swiss real estate investment firm specializing in high-end commercial and residential properties. It's our passion to navigate investors through the complexity of real estate markets. We focus on and cater to the very specific investment priorities of high net worth individuals and their families, as well as best-in-class institutional investors from around the world. We specialize in and pride ourselves on understanding our clients’ needs and investment criteria to deliver quality projects through rigorous research across our extensive and exclusive network. HvB provides investors access to Pangaea, our exclusive platform for high-end off-market real estate assets.`
                      )}
                    </Description>
                  </Intro>
                </StyledGrid>
                <StyledGrid md={1 / 8} />
              </div>
              <ContainerWithBorder>
                <StyledGrid md={1 / 5}>{t('Geneva')}</StyledGrid>
                <StyledGrid md={1 / 5}>{t('London')}</StyledGrid>
                <StyledGrid md={1 / 5}>{t('São Paulo')}</StyledGrid>
                <StyledGrid md={1 / 5}>{t('Singapore')}</StyledGrid>
                <StyledGrid md={1 / 5}>{t('Zurich')}</StyledGrid>
              </ContainerWithBorder>
            </Body>
            <Contacts>
              <Contact md={1 / 2}>{'invest@hvb-investments.com'}</Contact>
              <Contact md={1 / 2}>{'Münsterhof 6, 8001 Zürich'}</Contact>
            </Contacts>
          </div>
        )}
      </Container>
    )
  }
}

Landing.propTypes = {
  errorMessage: PropTypes.string,
  user: PropTypes.object,
  router: PropTypes.object,
  t: PropTypes.func,
  children: PropTypes.node
}

export default translate([ 'common', 'landing' ], { wait: true })(Landing)



// WEBPACK FOOTER //
// ./src/pages/Landing/index.js